import watch from "redux-watch";
import isEqual from 'is-equal';
import { deepmerge } from 'utilities/merge'
import './dialog.scss';

export default class DialogBase {
  scope: string;
  elementId: string;
  init(){
    this.scope = 'data.dialog';
    this.elementId = 'dialog-wrap';
    this.setEvent();
  }
  setEvent(){
    let w = watch(App.store.getState, this.scope, isEqual);
    App.store.subscribe(w((newVal, oldVal, objectPath) => {
      this.onEvent(newVal, oldVal, objectPath);
    }), true);
  }
  onEvent(newVal, oldVal, projectPath){
    if(newVal.options.method == 'show'){
      this.showDialog(newVal.options.type);
    } else if (newVal.options.method == 'hide'){
      this.hideDialog(newVal.options.type);
    }
  }
  public showDialog(type){
    let selector = this.modalSelector(type);
    $(selector).modal('show')
  }
  public hideDialog(type){
    let selector = this.modalSelector(type);
    $(selector).modal('hide')
  }
  modalSelector(type){
    return '#' + this.elementId+ ' ' + type + ' .modal';
  }
}
